import { createDestinationLanding } from '@/router/destinationRoute';
import { useCompanyDashboardAccess } from '@/abilities/companyDashboard/useCompanyDashboardAccess';
import { companyDashboardDestinationTree } from '@/abilities/companyDashboard/vocabulary';
import { companyDashboardDestinationRoutes } from '@/pages/company/DashboardRoute/destinationRoutes';

export const { landingPath: companyDashboardLandingPath, landing: companyDashboardLanding } = createDestinationLanding(
  companyDashboardDestinationTree,
  companyDashboardDestinationRoutes,
  useCompanyDashboardAccess,
);
